import { Injectable } from '@angular/core';
import { SessionService } from './SessionService';
import { environment } from '../../environments/environment';
import {_} from 'underscore';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CoachingService {
  private url: string;

  constructor(private http: HttpClient, private session: SessionService) {
    this.url = environment.api.myshiftUrl + '/teams/loadCoach';
  }

  loadHierarchy() {
    const options = { headers: this.session.getHttpHeaders() };
    return this.http.get(this.url, options)
        .map(response => response);
  }

  public hasSaisieCoach() {
    let hasSaisieCoach = false;
    const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
    if (user !== null) {
        let authorities = user.authorities.filter((i, n) => environment.clients.indexOf(i.clientId) > -1);
        if (authorities !== null && authorities.length > 0) {
            authorities.forEach(authority => {
                if (authority.permissions !== null && authority.permissions.indexOf('SAISIE_COACH') > -1) {
                    hasSaisieCoach = true;
                }
            });
        }
    }
    // console.log('hasSaisieCoach: ' + hasSaisieCoach);
    return hasSaisieCoach;
  }

}



// WEBPACK FOOTER //
// ./src/app/service/coaching.service.ts